import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
    private readonly gtmId = environment.gtmId;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

    public initGTM() {
        this.appendGTMScriptTagToHead();
        this.prependGTMNoscriptTagToBody();
    }

    private appendGTMScriptTagToHead(): void {
        if (!isPlatformBrowser(this.platformId) || document.getElementById('gtm-head-script')) {
            return;
        }
        const gtmCommentStart = document.createComment('Google Tag Manager');
        document.head.appendChild(gtmCommentStart);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const script = document.createElement('script');
        script.id = 'gtm-head-script';
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,
f);
})(window,document,'script','dataLayer','${this.gtmId}');`;
        document.head.appendChild(script);
        const gtmCommentEnd = document.createComment('End Google Tag Manager');
        document.head.appendChild(gtmCommentEnd);
    }

    private prependGTMNoscriptTagToBody(): void {
        if (!isPlatformBrowser(this.platformId) || document.getElementById('gtm-body-noscript')) {
            return;
        }
        const gtmCommentEnd = document.createComment('End Google Tag Manager (noscript)');
        document.body.prepend(gtmCommentEnd);
        const noscript = document.createElement('noscript');
        noscript.id = 'gtm-body-noscript';
        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${this.gtmId}`);
        iframe.setAttribute('height', '0');
        iframe.setAttribute('width', '0');
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        noscript.appendChild(iframe);
        document.body.prepend(noscript);
        const gtmCommentStart = document.createComment('Google Tag Manager (noscript)');
        document.body.prepend(gtmCommentStart);
    }
}

declare global {
    interface Window {
        dataLayer: any[];
    }
}
